import styled from 'styled-components';

export const IndexContainer = styled.span`
  margin-right: 4px;
`;
